import { z } from 'zod';

export const isBrowser = typeof window !== 'undefined';

export const Environment = z.enum(['LOCAL', 'PREVIEW', 'DEV', 'STAGE', 'PROD']);
export type Environment = z.infer<typeof Environment>;

export function getEnvironment(env: unknown): Environment {
  const environment = Environment.safeParse(env);

  if (!environment.success) {
    throw new Error('Unable to determine environment');
  }

  return environment.data;
}
